import React from 'react';
import { Reveal } from './Reveal';
import { PathThread } from './PathThread';
export function PostLaunchTruth() {
  return <section className="py-16 md:py-20 bg-paper-dark border-y border-gray-200 relative" data-id="element-436">
      <div className="absolute -top-12 left-1/2 -translate-x-1/2" data-id="element-437">
        <PathThread data-id="element-438" />
      </div>
      <div className="max-w-2xl mx-auto px-6 text-center" data-id="element-439">
        <Reveal data-id="element-440">
          <h2 className="text-2xl md:text-4xl font-serif text-navy mb-10 leading-tight" data-id="element-441">
            The book can look successful{' '}
            <span className="italic text-seaglass" data-id="element-442">
              and still feel underused
            </span>
          </h2>
        </Reveal>

        <Reveal delay={0.1} data-id="element-443">
          <div className="text-lg text-text-muted leading-relaxed space-y-5 mb-14" data-id="element-444">
            <p data-id="element-445">A serious nonfiction book is not a small thing.</p>
            <p data-id="element-446">
              It carries your thinking, stories, frameworks, language, point of
              view, and years of work most people never see.
            </p>
            <p data-id="element-447">So the problem is not that the book failed.</p>
            <p data-id="element-448">
              The book may have done its first job. It created credibility. It
              gave people a reason to trust you.
            </p>
            <p data-id="element-449">But credibility alone does not tell a reader what to do next.</p>
          </div>
        </Reveal>

        <Reveal delay={0.2} data-id="element-450">
          <div className="relative" data-id="element-451">
            <div className="w-10 h-0.5 bg-sand rounded-full mx-auto mb-7" data-id="element-452"></div>
            <p className="text-2xl md:text-3xl font-serif text-navy leading-snug" data-id="element-453">
              "The book may have worked. <br className="hidden md:block" data-id="element-454" />
              <span className="italic text-seaglass" data-id="element-455">
                The path after it may be what was missing.
              </span>
              "
            </p>
          </div>
        </Reveal>
      </div>
    </section>;
}